import { useSyncExternalStore } from 'react';

// One `resize` listener for the whole app, not one per component instance.
// The inbox mounts thousands of ChatContainer rows while virtuoso measures a
// long history; a listener each turns window's listener list into an O(n)
// scan on every add/remove, which freezes the tab on big chats.
const read = () => ({ width: window.innerWidth, height: window.innerHeight });

let dimensions = read();
const subscribers = new Set<() => void>();
let listening = false;

const handleResize = () => {
  const next = read();
  if (next.width === dimensions.width && next.height === dimensions.height)
    return;
  dimensions = next;
  subscribers.forEach(notify => notify());
};

const subscribe = (notify: () => void) => {
  subscribers.add(notify);
  if (!listening) {
    window.addEventListener('resize', handleResize);
    listening = true;
    // The module-eval read can be stale by now (rotation, devtools opening).
    handleResize();
  }
  return () => {
    subscribers.delete(notify);
  };
};

// Stable reference between resizes — useSyncExternalStore loops forever if the
// snapshot is a fresh object each call.
const getSnapshot = () => dimensions;

export default function useWindowDimensions() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
